import { render, staticRenderFns } from "./UnsubmittedIncidentsTable.vue?vue&type=template&id=739a0408&"
import script from "./UnsubmittedIncidentsTable.vue?vue&type=script&lang=js&"
export * from "./UnsubmittedIncidentsTable.vue?vue&type=script&lang=js&"
import style0 from "./UnsubmittedIncidentsTable.vue?vue&type=style&index=0&id=739a0408&prod&lang=scss&module=true&"
import style1 from "./UnsubmittedIncidentsTable.vue?vue&type=style&index=1&id=739a0408&prod&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports